// extracted by mini-css-extract-plugin
module.exports = {"text":"AnswerChoiceDropDown_text__3rH5T"};